import React from "react";
import { useDocumentContext } from "../../Documents";
import { CheckBox } from "../../../../components/reactHookFormFields/checkbox";

export const DocumentHeader = ({}) => {
  const documentContext = useDocumentContext();

  return (
    <thead className="bg-gray-c-150 border-left-teal-c-100-20">
      <tr>
        {/*<th scope="col" className="relative w-12 px-2">
          <input
            type="checkbox"
            className="h-4 w-4 mt-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
          />
  </th>*/}
        <th
          scope="col"
          className="flex gap-x-1 items-center w-[20%] py-1 px-2 text-left text-sm text-black-c-400 font-normal"
        >
          <CheckBox name="select_all" control={documentContext?.control} onChange={documentContext?.selectUnselectAll} />
          File
        </th>
        <th
          scope="col"
          className="w-[20%] px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Type
        </th>
        <th
          scope="col"
          className="w-[20%] px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Description
        </th>
        <th
          scope="col"
          className="w-[20%] px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Upload By
        </th>
        <th
          scope="col"
          className="w-[20%] px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Date
        </th>
        <th
          scope="col"
          className="w-[30%] px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Size
        </th>
        {/* <th
          scope="col"
          className="w-20 px-2 py-1 text-left text-sm text-black-c-400 font-normal"
        >
          Actions
        </th> */}
      </tr>
    </thead>
  );
};
